import Controller from "controllers/application_controller"
import { Turbo } from "@hotwired/turbo-rails"

/**
 * ConfirmManager is a singleton that manages the confirmation dialogs, to allow
 * the binding of custom dialogs for specific messages, as well as a default dialog.
 */
const ConfirmManager = new class {
  default = null
  messages = {}

  setupTurboHook() {
    Turbo.config.forms.confirm = this.confirm.bind(this)
  }

  register(dialog) {
    this.setupTurboHook()

    if (dialog.message) {
      this.messages[dialog.message] = dialog
    } else {
      this.default = dialog
    }
  }

  unregister(dialog) {
    if (dialog.message && this.messages[dialog.message] === dialog) {
      delete this.messages[dialog.message]
    } else if (this.default === dialog) {
      this.default = null
    }
  }

  confirm(message) {
    // if (message.charAt(0) === '{' && message.charAt(message.length - 1) === '}') {
    //   message = JSON.parse(message)
    // }

    if (this.default) {
      return this.default.confirm(message)
    }

    return this.nativeConfirm(message)
  }

  nativeConfirm(message) {
    return Promise.resolve(window.confirm(message))
  }
}

export default class ConfirmController extends Controller {
  static identifier = "confirm"
  static targets = ["message"]

  // Promise resolver for the confirmation action
  resolve = null

  get message() {
    return null
  }

  connect() {
    // Register the dialog as a confirm() handler
    ConfirmManager.register(this)

    // Listen for the dialog's cancel event (triggered by Escape key)
    this.addEventListener('cancel', (event) => this.cancel(event))

    // Click events shouldn't propagate outside of the dialog
    this.addEventListener('click', (event) => event.stopPropagation())
  }

  disconnect() {
    ConfirmManager.unregister(this)
    super.disconnect()
  }

  // Method to show the dialog and return a promise
  confirm(message) {
    // Update the message
    this.messageTarget.textContent = message || "Are you sure?"

    // Create a new promise that will be resolved based on user action
    return new Promise(resolve => {
      this.resolve = resolve
      this.element.showModal()
    })
  }

  // OK button handler - resolve with true to proceed with the action
  proceed(event) {
    this.element.close()
    this.resolve?.(true)
  }

  // Cancel button handler - resolve with false to cancel the action
  cancel(event) {
    this.element.close()
    this.resolve?.(false)
  }

}
